var _path, _path2, _g, _ellipse, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWell3Img(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0963 0.489849C20.5182 0.330942 19.908 0.330885 19.3299 0.489684L5.20383 4.36991C3.75653 4.76747 2.75342 6.08327 2.75342 7.58419V18.4974C2.75342 26.0418 9.22315 33.8782 18.8676 38.5903C19.7161 39.0049 20.71 39.0049 21.5585 38.5901C31.1997 33.8772 37.6601 26.0316 37.6601 18.4974V7.5837C37.6601 6.08301 36.6573 4.76735 35.2103 4.36959L21.0963 0.489849Z",
    fill: "#65A5FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_393_6539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 36,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2229 0.249023L2.76318 5.04496V18.4994C2.76318 26.3895 9.83944 34.599 20.2229 39.22C30.6037 34.599 37.6698 26.3789 37.6698 18.4994V5.04496L20.2229 0.249023Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_393_6539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.979 7.28228C19.2276 7.28907 19.4684 7.32804 19.7016 7.39924H19.7249C19.7407 7.40597 19.7526 7.41341 19.7605 7.42014C19.8477 7.44529 19.9302 7.47363 20.0091 7.5126L20.1591 7.57282C20.2183 7.60116 20.2894 7.65394 20.3288 7.67555C20.3683 7.69645 20.4117 7.71806 20.4472 7.7425C20.8857 7.44175 21.4182 7.2788 21.9668 7.28228C22.2159 7.28228 22.4645 7.31387 22.701 7.38507C24.1578 7.81017 24.6827 9.24487 24.2442 10.4989C23.9956 11.1397 23.589 11.7246 23.0566 12.2025C22.2944 12.8649 21.4581 13.453 20.5577 13.9595L20.4591 14.013L20.3565 13.956C19.453 13.453 18.6119 12.8649 17.8426 12.1989C17.3137 11.7211 16.9068 11.1397 16.6542 10.4989C16.2082 9.24487 16.7331 7.81017 18.2057 7.37763C18.3202 7.34221 18.4382 7.31741 18.5566 7.30359H18.604C18.7149 7.28907 18.825 7.28228 18.9355 7.28228H18.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.8194,
    cy: 16.3684,
    rx: 4.87722,
    ry: 4.87723,
    fill: "#070C1A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.2906,
    cy: 13.1053,
    rx: 2.03008,
    ry: 2.03008,
    fill: "#070C1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4597 30.8204C18.4597 25.9808 22.3829 22.0576 27.2225 22.0576C32.062 22.0576 35.9852 25.9808 35.9852 30.8204V35.0635H18.4597V30.8204Z",
    fill: "#070C1A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6255,
    cy: 16.3743,
    rx: 4.87722,
    ry: 4.87723,
    fill: "#070C1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.01123 30.8282C2.01123 25.9886 5.93445 22.0654 10.774 22.0654C15.6135 22.0654 19.5367 25.9886 19.5367 30.8282V35.0714H2.01123V30.8282Z",
    fill: "#070C1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5752 28.5664C22.3709 28.5664 23.8267 27.1107 23.8267 25.315C23.8267 23.5192 22.3709 22.0635 20.5752 22.0635C18.7794 22.0635 17.3237 23.5192 17.3237 25.315C17.3237 27.1107 18.7794 28.5664 20.5752 28.5664ZM19.9507 29.3818C15.8085 29.3818 12.4507 32.7397 12.4507 36.8818V39.1363H27.8952V36.8818C27.8952 32.7397 24.5374 29.3818 20.3952 29.3818H19.9507Z",
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.28616,
    cy: 30.5833,
    rx: 7.44363,
    ry: 7.44363,
    fill: "#00A661"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29028 26.8643V34.3079",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56641 30.5889H12.01",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWell3Img);
export default __webpack_public_path__ + "static/media/well-3-img.4246063e27ae28f8c824ee8cf6dab882.svg";
export { ForwardRef as ReactComponent };